[
    {
        "name": "India",
        "dial_code": "+91",
        "flag_position": "0px -1694px"
    },
    {
        "name": "United States",
        "dial_code": "+1",
        "flag_position": "0px -44px"
    },
    {
        "name": "Afghanistan",
        "dial_code": "+93",
        "flag_position": "0px -2311px"
    },
    
    {
        "name": "Albania",
        "dial_code": "+355",
        "flag_position": "0px -1034px"
    },
    {
        "name": "Algeria",
        "dial_code": "+213",
        "flag_position": "0px -528px"
    },
    {
        "name": "AmericanSamoa",
        "dial_code": "+1684",
        "flag_position": "0px -1562px"
    },
    {
        "name": "Andorra",
        "dial_code": "+376",
        "flag_position": "0px -594px"
    },
    {
        "name": "Angola",
        "dial_code": "+244",
        "flag_position": "0px -1947px"
    },
    {
        "name": "Anguilla",
        "dial_code": "+1264",
        "flag_position": "0px -1980px"
    },
    
    {
        "name": "Antigua and Barbuda",
        "dial_code": "+1268",
        "flag_position": "0px -869px"
    },
    {
        "name": "Argentina",
        "dial_code": "+54",
        "flag_position": "0px -2377px"
    },
    {
        "name": "Armenia",
        "dial_code": "+374",
        "flag_position": "0px -176px"
    },
    {
        "name": "Aruba",
        "dial_code": "+297",
        "flag_position": "0px -792px"
    },
    {
        "name": "Ascension Island",
        "dial_code": "+247",
        "flag_position": "0px -55px"
    },

    {
        "name": "Australia",
        "dial_code": "+61",
        "flag_position": "0px -1716px"
    },
    {
        "name": "Austria",
        "dial_code": "+43",
        "flag_position": "0px -1331px"
    },
    {
        "name": "Azerbaijan",
        "dial_code": "+994",
        "flag_position": "0px -1243px"
    },
    {
        "name": "Bahamas",
        "dial_code": "+1242",
        "flag_position": "0px -363px"
    },
    {
        "name": "Bahrain",
        "dial_code": "+973",
        "flag_position": "0px -1496px"
    },
    {
        "name": "Bangladesh",
        "dial_code": "+880",
        "flag_position": "0px -1771px"
    },
    {
        "name": "Barbados",
        "dial_code": "+1246",
        "flag_position": "0px -1573px"
    },
    {
        "name": "Belarus",
        "dial_code": "+375",
        "flag_position": "0px -1100px"
    },
    {
        "name": "Belgium",
        "dial_code": "+32",
        "flag_position": "0px 0px"
    },
    {
        "name": "Belize",
        "dial_code": "+501",
        "flag_position": "0px -484px"
    },
    {
        "name": "Benin",
        "dial_code": "+229",
        "flag_position": "0px -1298px"
    },
    {
        "name": "Bermuda",
        "dial_code": "+1441",
        "flag_position": "0px -1914px"
    },
    {
        "name": "Bhutan",
        "dial_code": "+975",
        "flag_position": "0px -1848px"
    },
    {
        "name": "Bolivia",
        "dial_code": "+591",
        "flag_position": "0px -1650px"
    },
    {
        "name": "Bonaire,Sint Eustatius",
        "dial_code": "+599",
        "flag_position": "0px -2719px"
    },
    {
        "name": "Bosnia and Herzegovina",
        "dial_code": "+387",
        "flag_position": "0px -1584px"
    },
    {
        "name": "Botswana",
        "dial_code": "+267",
        "flag_position": "0px -2707px"
    },
    {
        "name": "Brazil",
        "dial_code": "+55",
        "flag_position": "0px -770px"
    },
    {
        "name": "British Indian Ocean Territory",
        "dial_code": "+246",
        "flag_position": "0px -1650px"
    },
    {
        "name": "Brunei Darussalam",
        "dial_code": "+673",
        "flag_position": "0px -1683px"
    },
    {
        "name": "Bulgaria",
        "dial_code": "+359",
        "flag_position": "0px -2586px"
    },
    {
        "name": "Burkina Faso",
        "dial_code": "+226",
        "flag_position": "0px -726px"
    },
    {
        "name": "Burundi",
        "dial_code": "+257",
        "flag_position": "0px -1892px"
    },
    {
        "name": "Cambodia",
        "dial_code": "+855",
        "flag_position": "0px -242px"
    },
    {
        "name": "Cameroon",
        "dial_code": "+237",
        "flag_position": "0px -2057px"
    },
    {
        "name": "Canada",
        "dial_code": "+1",
        "flag_position": "0px -1375px"
    },
    {
        "name": "Cape Verde",
        "dial_code": "+238",
        "flag_position": "0px -2652px"
    },
    {
        "name": "Cayman Islands",
        "dial_code": "+ 345",
        "flag_position": "0px -308px"
    },
    {
        "name": "Central African Republic",
        "dial_code": "+236",
        "flag_position": "0px -1837px"
    },
    {
        "name": "Chad",
        "dial_code": "+235",
        "flag_position": "0px -814px"
    },
    {
        "name": "Chile",
        "dial_code": "+56",
        "flag_position": "00px -1342px"
    },
    {
        "name": "China",
        "dial_code": "+86",
        "flag_position": "0px -825px"
    },
  
    {
        "name": "Colombia",
        "dial_code": "+57",
        "flag_position": "0px -330px"
    },
    {
        "name": "Comoros",
        "dial_code": "+269",
        "flag_position": "0px -1430px"
    },
    {
        "name": "Congo",
        "dial_code": "+242",
        "flag_position": "0px -1793px"
    },
    {
        "name": "Congo, The Democratic Republic of the Congo",
        "dial_code": "+243",
        "flag_position": "0px -1518px"
    },
    {
        "name": "Cook Islands",
        "dial_code": "+682",
        "flag_position": "0px -2267px"
    },
    {
        "name": "Costa Rica",
        "dial_code": "+506",
        "flag_position": "0px -2090px"
    },
    {
        "name": "Cote d'Ivoire",
        "dial_code": "+225",
        "flag_position": "0px -1661px"
    },
    {
        "name": "Croatia",
        "dial_code": "+385",
        "flag_position": "0px -902px"
    },
    {
        "name": "Cuba",
        "dial_code": "+53",
        "flag_position": "0px -748px"
    },
    {
        "name": "Curaçao",
        "dial_code": "+599",
        "flag_position": "0px -2729px"
    },

    {
        "name": "Cyprus",
        "dial_code": "+357",
        "flag_position": "0px -561px"
    },
    {
        "name": "Czech Republic",
        "dial_code": "+420",
        "flag_position": "0px -2256px"
    },
    {
        "name": "Denmark",
        "dial_code": "+45",
        "flag_position": "0px -1386px"
    },
    {
        "name": "Diego Garcia",
        "dial_code": "+246",
        "flag_position": "0px -55px"
    },
    {
        "name": "Djibouti",
        "dial_code": "+253",
        "flag_position": "0px -2101px"
    },
    {
        "name": "Dominica",
        "dial_code": "+1767",
        "flag_position": "0px -2432px"
    },
    {
        "name": "Dominican Republic",
        "dial_code": "+1849",
        "flag_position": "0px -1529px"
    },
    {
        "name": "Ecuador",
        "dial_code": "+593",
        "flag_position": "0px -1188px"
    },
    {
        "name": "Egypt",
        "dial_code": "+20",
        "flag_position": "0px -2201px"
    },
    {
        "name": "El Salvador",
        "dial_code": "+503",
        "flag_position": "0px -1639px"
    },
    {
        "name": "Equatorial Guinea",
        "dial_code": "+240",
        "flag_position": "0px -1507px"
    },
    {
        "name": "Eritrea",
        "dial_code": "+291",
        "flag_position": "0px -715px"
    },
    {
        "name": "Estonia",
        "dial_code": "+372",
        "flag_position": "0px -2410px"
    },
    {
        "name": "Ethiopia",
        "dial_code": "+251",
        "flag_position": "0px -2443px"
    },
    {
        "name": "Falkland Islands (Malvinas)",
        "dial_code": "+500",
        "flag_position": "0px -2762px"
    },
    {
        "name": "Faroe Islands",
        "dial_code": "+298",
        "flag_position": "0px -1111px"
    },
    {
        "name": "Fiji",
        "dial_code": "+679",
        "flag_position": "0px -1859px"
    },
    {
        "name": "Finland",
        "dial_code": "+358",
        "flag_position": "0px -1903px"
    },
    {
        "name": "France",
        "dial_code": "+33",
        "flag_position": "0px -1012px"
    },
    {
        "name": "French Guiana",
        "dial_code": "+594",
        "flag_position": "0px -2234px"
    },
    {
        "name": "French Polynesia",
        "dial_code": "+689",
        "flag_position": "0px -1705px"
    },
    {
        "name": "Gabon",
        "dial_code": "+241",
        "flag_position": "0px -880px"
    },
    {
        "name": "Gambia",
        "dial_code": "+220",
        "flag_position": "0px -627px"
    },
    {
        "name": "Georgia",
        "dial_code": "+995",
        "flag_position": "0px -858px"
    },
    {
        "name": "Germany",
        "dial_code": "+49",
        "flag_position": "0px -2509px"
    },
    {
        "name": "Ghana",
        "dial_code": "+233",
        "flag_position": "0px -2112px"
    },
    {
        "name": "Gibraltar",
        "dial_code": "+350",
        "flag_position": "0px -275px"
    },
    {
        "name": "Greece",
        "dial_code": "+30",
        "flag_position": "0px -165px"
    },
    {
        "name": "Greenland",
        "dial_code": "+299",
        "flag_position": "0px -1760px"
    },
    {
        "name": "Grenada",
        "dial_code": "+1473",
        "flag_position": "0px -2399px"
    },
    {
        "name": "Guadeloupe",
        "dial_code": "+590",
        "flag_position": "0px -407px"
    },
    {
        "name": "Guam",
        "dial_code": "+1671",
        "flag_position": "0px -2366px"
    },
    {
        "name": "Guatemala",
        "dial_code": "+502",
        "flag_position": "0px -935px"
    },
   
    {
        "name": "Guinea",
        "dial_code": "+224",
        "flag_position": "0px -2575px"
    },
    {
        "name": "Guinea-Bissau",
        "dial_code": "+245",
        "flag_position": "0px -1925px"
    },
    {
        "name": "Guyana",
        "dial_code": "+595",
        "flag_position": "0px -803px"
    },
    {
        "name": "Haiti",
        "dial_code": "+509",
        "flag_position": "0px -319px"
    },
   
    {
        "name": "Honduras",
        "dial_code": "+504",
        "flag_position": "0px -2156px"
    },
    {
        "name": "Hong Kong",
        "dial_code": "+852",
        "flag_position": "0px -2696px"
    },
    {
        "name": "Hungary",
        "dial_code": "+36",
        "flag_position": "0px -682px"
    },
    {
        "name": "Iceland",
        "dial_code": "+354",
        "flag_position": "0px -1991px"
    },
    {
        "name": "Indonesia",
        "dial_code": "+62",
        "flag_position": "0px -1958px"
    },
    {
        "name": "Iran",
        "dial_code": "+98",
        "flag_position": "0px -2013px"
    },
    {
        "name": "Iraq",
        "dial_code": "+964",
        "flag_position": "0px -649px"
    },
    {
        "name": "Ireland",
        "dial_code": "+353",
        "flag_position": "0px -1969px"
    },
    
    {
        "name": "Israel",
        "dial_code": "+972",
        "flag_position": "0px -341px"
    },
    {
        "name": "Italy",
        "dial_code": "+39",
        "flag_position": "0px -143px"
    },
    {
        "name": "Jamaica",
        "dial_code": "+1876",
        "flag_position": "0px -1727px"
    },
    {
        "name": "Japan",
        "dial_code": "+81",
        "flag_position": "0px -429px"
    },
    
    {
        "name": "Jordan",
        "dial_code": "+962",
        "flag_position": "0px -1463px"
    },
    {
        "name": "Kazakhstan",
        "dial_code": "+77",
        "flag_position": "0px -1210px"
    },
    {
        "name": "Kenya",
        "dial_code": "+254",
        "flag_position": "0px -2630px"
    },
    {
        "name": "Kiribati",
        "dial_code": "+686",
        "flag_position": "0px -374px"
    },
    {
        "name": "Korea North",
        "dial_code": "+850",
        "flag_position": "0px -1804px"
    },
    {
        "name": "Korea South",
        "dial_code": "+82",
        "flag_position": "0px -2245px"
    },
    {
        "name": "Kuwait",
        "dial_code": "+965",
        "flag_position": "0px -2487px"
    },
    {
        "name": "Kyrgyzstan",
        "dial_code": "+996",
        "flag_position": "0px -1617px"
    },
    {
        "name": "Laos",
        "dial_code": "+856",
        "flag_position": "0px -451px"
    },
    {
        "name": "Latvia",
        "dial_code": "+371",
        "flag_position": "0px -1936px"
    },
    {
        "name": "Lebanon",
        "dial_code": "+961",
        "flag_position": "0px -1254px"
    },
    {
        "name": "Lesotho",
        "dial_code": "+266",
        "flag_position": "0px -2190px"
    },
    {
        "name": "Liberia",
        "dial_code": "+231",
        "flag_position": "0px -2068px"
    },
    {
        "name": "Libyan Arab Jamahiriya",
        "dial_code": "+218",
        "flag_position": "0px -132px"
    },
    {
        "name": "Liechtenstein",
        "dial_code": "+423",
        "flag_position": "0px -979px"
    },
    {
        "name": "Lithuania",
        "dial_code": "+370",
        "flag_position": "0px -1122px"
    },
    {
        "name": "Luxembourg",
        "dial_code": "+352",
        "flag_position": "0px -1474px"
    },
    {
        "name": "Macao",
        "dial_code": "+853",
        "flag_position": "0px -2597px"
    },
    {
        "name": "Macedonia",
        "dial_code": "+389",
        "flag_position": "0px -1353px"
    },
    {
        "name": "Madagascar",
        "dial_code": "+261",
        "flag_position": "0px -1287px"
    },
    {
        "name": "Malawi",
        "dial_code": "+265",
        "flag_position": "0px -2145px"
    },
    {
        "name": "Malaysia",
        "dial_code": "+60",
        "flag_position": "0px -1870px"
    },
    {
        "name": "Maldives",
        "dial_code": "+960",
        "flag_position": "0px -616px"
    },
    {
        "name": "Mali",
        "dial_code": "+223",
        "flag_position": "0px -2520px"
    },
    {
        "name": "Malta",
        "dial_code": "+356",
        "flag_position": "0px -1551px"
    },
    {
        "name": "Marshall Islands",
        "dial_code": "+692",
        "flag_position": "0px -1144px"
    },
    {
        "name": "Martinique",
        "dial_code": "+596",
        "flag_position": "0px -198px"
    },
    {
        "name": "Mauritania",
        "dial_code": "+222",
        "flag_position": "0px -253px"
    },
    {
        "name": "Mauritius",
        "dial_code": "+230",
        "flag_position": "0px -2179px"
    },
   
    {
        "name": "Mexico",
        "dial_code": "+52",
        "flag_position": "0px -2024px"
    },
    {
        "name": "Micronesia",
        "dial_code": "+691",
        "flag_position": "0px -1738px"
    },
    {
        "name": "Moldova",
        "dial_code": "+373",
        "flag_position": "0px -2685px"
    },
    {
        "name": "Monaco",
        "dial_code": "+377",
        "flag_position": "0px -913px"
    },
    {
        "name": "Mongolia",
        "dial_code": "+976",
        "flag_position": "0px -2553px"
    },
    {
        "name": "Montenegro",
        "dial_code": "+382",
        "flag_position": "0px -2167px"
    },
    {
        "name": "Montserrat",
        "dial_code": "+1664",
        "flag_position": "0px -583px"
    },
    {
        "name": "Morocco",
        "dial_code": "+212",
        "flag_position": "0px -2333px"
    },
    {
        "name": "Mozambique",
        "dial_code": "+258",
        "flag_position": "0px -638px"
    },
    {
        "name": "Myanmar",
        "dial_code": "+95",
        "flag_position": "0px -11px"
    },
    {
        "name": "Namibia",
        "dial_code": "+264",
        "flag_position": "0px -1881px"
    },
    {
        "name": "Nauru",
        "dial_code": "+674",
        "flag_position": "0px -1749px"
    },
    {
        "name": "Nepal",
        "dial_code": "+977",
        "flag_position": "0px -110px"
    },
    {
        "name": "Netherlands",
        "dial_code": "+31",
        "flag_position": "0px -1441px"
    },
    
    {
        "name": "New Caledonia",
        "dial_code": "+687",
        "flag_position": "0px -1276px"
    },
    {
        "name": "New Zealand",
        "dial_code": "+64",
        "flag_position": "0px -1540px"
    },
    {
        "name": "Nicaragua",
        "dial_code": "+505",
        "flag_position": "0px -154px"
    },
    {
        "name": "Niger",
        "dial_code": "+227",
        "flag_position": "0px -550px"
    },
    {
        "name": "Nigeria",
        "dial_code": "+234",
        "flag_position": "0px -2476px"
    },
    {
        "name": "Niue",
        "dial_code": "+683",
        "flag_position": "0px -2079px"
    },
    {
        "name": "Norfolk Island",
        "dial_code": "+672",
        "flag_position": "0px -209px"
    },
    {
        "name": "Northern Mariana Islands",
        "dial_code": "+1670",
        "flag_position": "0px -704px"
    },
    {
        "name": "Norway",
        "dial_code": "+47",
        "flag_position": "0px -836px"
    },
    {
        "name": "Oman",
        "dial_code": "+968",
        "flag_position": "0px -1652454px0px"
    },
    {
        "name": "Pakistan",
        "dial_code": "+92",
        "flag_position": "0px -2035px"
    },
    {
        "name": "Palau",
        "dial_code": "+680",
        "flag_position": "0px -231px"
    },
    {
        "name": "Palestinian Territory, Occupied",
        "dial_code": "+970",
        "flag_position": "0px -1199px"
    },
    {
        "name": "Panama",
        "dial_code": "+507",
        "flag_position": "0px -847px"
    },
    {
        "name": "Papua New Guinea",
        "dial_code": "+675",
        "flag_position": "0px -1485px"
    },
    {
        "name": "Paraguay",
        "dial_code": "+595",
        "flag_position": "0px -2344px"
    },
    {
        "name": "Peru",
        "dial_code": "+51",
        "flag_position": "0px -946px"
    },
    {
        "name": "Philippines",
        "dial_code": "+63",
        "flag_position": "0px -1815px"
    },
   
    {
        "name": "Poland",
        "dial_code": "+48",
        "flag_position": "0px -1177px"
    },
    {
        "name": "Portugal",
        "dial_code": "+351",
        "flag_position": "0px -517px"
    },
    {
        "name": "Puerto Rico",
        "dial_code": "+1939",
        "flag_position": "0px -473px"
    },
    {
        "name": "Qatar",
        "dial_code": "+974",
        "flag_position": "0px -462px"
    },
    {
        "name": "Reunion",
        "dial_code": "+262",
        "flag_position": "0px -264px"
    },
    {
        "name": "Romania",
        "dial_code": "+40",
        "flag_position": "0px -671px"
    },
    {
        "name": "Russia",
        "dial_code": "+7",
        "flag_position": "0px -660px"
    },
    {
        "name": "Rwanda",
        "dial_code": "+250",
        "flag_position": "0px -2674px"
    },
    {
        "name": "Saba",
        "dial_code": "+599",
        "flag_position": "0px -2719px"
    },
    
    {
        "name": "Saint Barthelemy",
        "dial_code": "+590",
        "flag_position": "0px -1012px"
    },
    {
        "name": "Saint Helena",
        "dial_code": "+290",
        "flag_position": "0px -495px"
    },
    {
        "name": "Saint Kitts and Nevis",
        "dial_code": "+1869",
        "flag_position": "0px -99px"
    },
    {
        "name": "Saint Lucia",
        "dial_code": "+1758",
        "flag_position": "0px -1397px"
    },
    {
        "name": "Saint Martin",
        "dial_code": "+590",
        "flag_position": "0px -55px"
    },
    {
        "name": "Saint Pierre and Miquelon",
        "dial_code": "+508",
        "flag_position": "0px -1078px"
    },
    {
        "name": "Saint Vincent and the Grenadines",
        "dial_code": "+1784",
        "flag_position": "0px -2619px"
    },
    {
        "name": "Samoa",
        "dial_code": "+685",
        "flag_position": "0px -2300px"
    },
    {
        "name": "San Marino",
        "dial_code": "+378",
        "flag_position": "0px -2123px"
    },
    {
        "name": "Sao Tome and Principe",
        "dial_code": "+239",
        "flag_position": "0px -2388px"
    },
    {
        "name": "Saudi Arabia",
        "dial_code": "+966",
        "flag_position": "0px -33px"
    },
    {
        "name": "Senegal",
        "dial_code": "+221",
        "flag_position": "0px -2134px"
    },
    {
        "name": "Serbia",
        "dial_code": "+381",
        "flag_position": "0px -2465px"
    },
    {
        "name": "Seychelles",
        "dial_code": "+248",
        "flag_position": "0px -1045px"
    },
    {
        "name": "Sierra Leone",
        "dial_code": "+232",
        "flag_position": "0px -737px"
    },
    {
        "name": "Singapore",
        "dial_code": "+65",
        "flag_position": "0px -22px"
    },
    {
        "name": "Sint Maarten",
        "dial_code": "+1721",
        "flag_position": "0px -2773px"
    },
    {
        "name": "Slovakia",
        "dial_code": "+421",
        "flag_position": "0px -2212px"
    },
    {
        "name": "Slovenia",
        "dial_code": "+386",
        "flag_position": "0px -1221px"
    },
    {
        "name": "Solomon Islands",
        "dial_code": "+677",
        "flag_position": "0px -1067px"
    },
    {
        "name": "Somalia",
        "dial_code": "+252",
        "flag_position": "0px -1364px"
    },
    {
        "name": "South Africa",
        "dial_code": "+27",
        "flag_position": "0px -2355px"
    },
    {
        "name": "South Sudan",
        "dial_code": "+211",
        "flag_position": "0px -2741px"
    },
    
    {
        "name": "Spain",
        "dial_code": "+34",
        "flag_position": "0px -1155px"
    },
    {
        "name": "Sri Lanka",
        "dial_code": "+94",
        "flag_position": "0px -2641px"
    },
    {
        "name": "Sudan",
        "dial_code": "+249",
        "flag_position": "0px -352px"
    },
    {
        "name": "Suriname",
        "dial_code": "+597",
        "flag_position": "0px -2663px"
    },
    
    {
        "name": "Swaziland",
        "dial_code": "+268",
        "flag_position": "0px -2278px"
    },
    {
        "name": "Sweden",
        "dial_code": "+46",
        "flag_position": "0px -385px"
    },
    {
        "name": "Switzerland",
        "dial_code": "+41",
        "flag_position": "0px -1320px"
    },
    {
        "name": "Syrian Arab Republic",
        "dial_code": "+963",
        "flag_position": "0px -1826px"
    },
    {
        "name": "Taiwan",
        "dial_code": "+886",
        "flag_position": "0px -506px"
    },
    {
        "name": "Tajikistan",
        "dial_code": "+992",
        "flag_position": "0px -187px"
    },
    {
        "name": "Tanzania",
        "dial_code": "+255",
        "flag_position": "0px -2289px"
    },
    {
        "name": "Thailand",
        "dial_code": "+66",
        "flag_position": "0px -957px"
    },
    {
        "name": "Timor-Leste",
        "dial_code": "+670",
        "flag_position": "0px -2784px"
    },
    {
        "name": "Togo",
        "dial_code": "+228",
        "flag_position": "0px -605px"
    },
    {
        "name": "Tokelau",
        "dial_code": "+690",
        "flag_position": "0px -2751px"
    },
    {
        "name": "Tonga",
        "dial_code": "+676",
        "flag_position": "0px -1089px"
    },
    {
        "name": "Trinidad and Tobago",
        "dial_code": "+1868",
        "flag_position": "0px -440px"
    },
    {
        "name": "Tunisia",
        "dial_code": "+216",
        "flag_position": "0px -539px"
    },
    {
        "name": "Turkey",
        "dial_code": "+90",
        "flag_position": "0px -1606px"
    },
    {
        "name": "Turkmenistan",
        "dial_code": "+993",
        "flag_position": "0px -2542px"
    },
    {
        "name": "Turks and Caicos Islands",
        "dial_code": "+1649",
        "flag_position": "0px -1309px"
    },
    {
        "name": "Tuvalu",
        "dial_code": "+688",
        "flag_position": "0px -286px"
    },
    {
        "name": "Uganda",
        "dial_code": "+256",
        "flag_position": "0px -1166px"
    },
    {
        "name": "Ukraine",
        "dial_code": "+380",
        "flag_position": "0px -2002px"
    },
    {
        "name": "United Arab Emirates",
        "dial_code": "+971",
        "flag_position": "0px -2223px"
    },
    {
        "name": "United Kingdom",
        "dial_code": "+44",
        "flag_position": "0px -55px"
    },

    {
        "name": "Uruguay",
        "dial_code": "+598",
        "flag_position": "0px -2608px"
    },
    {
        "name": "Uzbekistan",
        "dial_code": "+998",
        "flag_position": "0px -1001px"
    },
    {
        "name": "Vanuatu",
        "dial_code": "+678",
        "flag_position": "0px -1265px"
    },
    {
        "name": "Vatican City",
        "dial_code": "+379",
        "flag_position": "0px -2322px"
    },
    {
        "name": "Venezuela",
        "dial_code": "+58",
        "flag_position": "0px -1056px"
    },
    {
        "name": "Vietnam",
        "dial_code": "+84",
        "flag_position": "0px -968px"
    },
    {
        "name": "Virgin Islands, British",
        "dial_code": "+1284",
        "flag_position": "0px -1408px"
    },
    {
        "name": "Virgin Islands, U.S.",
        "dial_code": "+1340",
        "flag_position": "0px -1782px"
    },
    {
        "name": "Wallis and Futuna",
        "dial_code": "+681",
        "flag_position": "0px -1012px"
    },
    {
        "name": "Yemen",
        "dial_code": "+967",
        "flag_position": "0px -1672px"
    },
    {
        "name": "Zambia",
        "dial_code": "+260",
        "flag_position": "0px -1595px"
    },
    {
        "name": "Zimbabwe",
        "dial_code": "+263",
        "flag_position": "0px -2046px"
    }
]